class EventInfoController {
  constructor(DateTimeService, APPLICATION_URL, LanguageService) {
    "ngInject";
    this.DateTimeService = DateTimeService;
    this.APPLICATION_URL = APPLICATION_URL;
    this.LanguageService = LanguageService;
  }

  get eventStartTime() {
    return this.event && this.event.start_timestamp;
  }

  get eventStartTimeInEventTimezone() {
    const startTime = this.event && this.event.start_timestamp;
    const eventTimezoneName = this.event && this.event.timezoneName;
    const moment = this.DateTimeService.parseMomentWithTimezone(startTime, eventTimezoneName);
    return moment;
  }

  get eventEndTimeInEventTimezone() {
    const endTime = this.event && this.event.end_timestamp;
    const eventTimezoneName = this.event && this.event.timezoneName;
    const moment = this.DateTimeService.parseMomentWithTimezone(endTime, eventTimezoneName);
    return moment;
  }

  seteventTimesinEventTimezone() {
    let times = []
    let eventTimezoneName = this.event && this.event.timezoneName;
    if (this.event && this.event.date && this.event.date.length){
      for (let di = 0; di < this.event.date.length; di++) {
          if(this.event.date[di] && this.event.start_time[di]){
            let dateString = this.event.date[di]+" "+this.event.start_time[di];
            let startDate = this.DateTimeService.parseMomentWithTimezone(dateString, eventTimezoneName);
            times.push(startDate);
          }
      }
    }
    else{
      times.push(this.eventEndTimeInEventTimezone);
    }
    return times;
  }
  get eventEndTime() {
    return this.event && this.event.end_timestamp;
  }

  get eventTimesinEventTimezone(){
    if(!this._eventTimesinEventTimezone){
      this._eventTimesinEventTimezone = this.seteventTimesinEventTimezone();
    }
    return this._eventTimesinEventTimezone;
  }

  get pdfLink() {
    if ( !this.recapResponse ) return false;

    let url = this.APPLICATION_URL + '/recaps/pdf.php?event_id='
        + this.event.id +
        "&recap_id="
        + this.recapResponse.events_recaps_id +
        "&lang="
        + this.LanguageService.activeLanguage.locale;

    if (this.recapResponse.position) {
      url += "&position_id="
        + this.recapResponse.position.position_id;
    }

    return url;

  }

}

export default EventInfoController;
